<div class="link-card">
  <div class="link-img">
    <img [src]="link?.img" />
  </div>
  <div class="link-text" (click)="goto(link.text)" [title]="link?.text">
    {{ link?.text }}
  </div>
</div>
